import { ReactSVG } from 'react-svg'
import { cn } from '~/@/lib/utils'

export function PivotTableIcon({
  size = 16,
  className,
}: {
  size?: number | string
  className?: string
}) {
  return (
    <ReactSVG
      beforeInjection={(svg) => {
        // Find all paths and set their fill to currentColor
        svg.querySelectorAll('path').forEach((path) => {
          path.setAttribute('fill', 'currentColor')
        })
      }}
      className={cn('fill-current', className)}
      src={`/assets/charts/pivot.svg`}
      style={{ height: size, width: size }}
      title="Pivot Table"
    />
  )
}
